import React from "react";
import "./legal.css";

const Terms = () => {
  return (
    <div className="legal-page">
      <div className="legal-container">
        <h1>Terms and Conditions</h1>
        <div className="legal-content">
          <p><strong>Last Updated: March 30, 2025</strong></p>
          <p>
            Welcome to Customs Pro AI ("we," "us," or "our"), a subscription-based service provided by Customs Pro AI, based in Melbourne, Australia. These Terms and Conditions ("Terms") govern your access to and use of our web application (the "Service"), which uses artificial intelligence to classify goods according to their Harmonized System (HS) codes. By registering for an account and using the Service, you agree to be bound by these Terms. If you do not agree, please do not use the Service.
          </p>

          <h2>1. Eligibility</h2>
          <p>You must be at least 18 years old and capable of entering into a legally binding agreement to use the Service. By registering, you confirm that you meet these requirements.</p>

          <h2>2. Subscription Plans</h2>
          <p>We offer two subscription tiers:</p>
          <ul>
            <li><strong>Standard:</strong> AUD $49 per month (GST inclusive), providing access to basic HS code classification features.</li>
            <li><strong>Professional:</strong> AUD $89 per month (GST inclusive), providing access to advanced features and additional tools (specific features detailed on our pricing page).</li>
          </ul>
          <p>Subscriptions are billed monthly in advance and renew automatically until canceled. Discounts apply for annual subscriptions, which are billed annually in advance and renew automatically until canceled.</p>
          <p>All payments are processed securely through Stripe, our third-party payment processor.</p>

          <h2>3. Account Registration</h2>
          <p>To use the Service, you must create an account via our registration page and agree to these Terms. You are responsible for:</p>
          <ul>
            <li>Providing accurate and complete information during registration.</li>
            <li>Keeping your login credentials secure and confidential.</li>
            <li>Notifying us immediately of any unauthorized use of your account.</li>
          </ul>

          <h2>4. Payment Terms</h2>
          <p>
            Payments are due on the first day of each billing cycle.<br />
            All fees are in Australian Dollars (AUD) and include Goods and Services Tax (GST) as required by Australian law.<br />
            All fees are non-refundable, except as required by applicable law (e.g., under the Australian Consumer Law).<br />
            If payment fails, we may suspend your access to the Service until payment is received.<br />
            We reserve the right to change pricing with 30 days’ notice via email or an in-app announcement.
          </p>

          <h2>5. Use of the Service</h2>
          <p>You agree to:</p>
          <ul>
            <li>Use the Service only for lawful purposes and in accordance with these Terms.</li>
            <li>Provide accurate input data for HS code classification, understanding that the AI’s output depends on the quality of your input.</li>
            <li>Not attempt to reverse-engineer, decompile, or otherwise interfere with the Service’s functionality.</li>
          </ul>
          <p>
            The Service is provided "as is." While we strive for accuracy in HS code classification, results are generated by AI and may not always be perfect. You are responsible for verifying classifications before relying on them for legal, commercial, or other purposes, including compliance with Australian customs regulations.
          </p>

          <h2>6. Intellectual Property</h2>
          <p>
            We retain all rights, title, and interest in the Service, including the AI technology, algorithms, and any content we provide.<br />
            You retain ownership of the data you upload but grant us a non-exclusive, worldwide, royalty-free license to use, process, and store it as necessary to provide the Service.
          </p>

          <h2>7. Cancellation and Termination</h2>
          <p>
            <strong>Your Cancellation:</strong> You may cancel your subscription at any time via your account settings. Cancellation takes effect at the end of your current billing cycle, and no prorated refunds will be issued unless required by law.<br />
            <strong>Our Termination:</strong> We may suspend or terminate your access if you violate these Terms, fail to pay, or if we discontinue the Service (with reasonable notice where possible).
          </p>

          <h2>8. Limitation of Liability</h2>
          <p>To the fullest extent permitted by law, including the Australian Consumer Law:</p>
          <ul>
            <li>We are not liable for indirect, incidental, or consequential damages arising from your use of the Service.</li>
            <li>Our total liability shall not exceed the amount you paid us in the preceding 12 months.</li>
            <li>We do not guarantee that the Service will be uninterrupted, error-free, or 100% accurate in HS code classification.</li>
          </ul>

          <h2>9. Indemnification</h2>
          <p>
            You agree to indemnify and hold us harmless from any claims, losses, or damages arising from your use of the Service, your violation of these Terms, or your infringement of any third-party rights.
          </p>

          <h2>10. Changes to These Terms</h2>
          <p>
            We may update these Terms from time to time. We’ll notify you of material changes via email or an in-app notice at least 30 days before they take effect. Continued use of the Service after changes constitutes acceptance of the updated Terms.
          </p>

          <h2>11. Governing Law</h2>
          <p>
            These Terms are governed by the laws of Victoria, Australia. Any disputes will be resolved in the courts of Victoria, subject to your rights under the Australian Consumer Law.
          </p>

          <h2>12. Australian Consumer Law</h2>
          <p>
            Nothing in these Terms excludes, restricts, or modifies any consumer guarantees or remedies you may have under the Australian Consumer Law. If the Service fails to meet a consumer guarantee, you may be entitled to a remedy (e.g., refund, repair, or replacement) as applicable.
          </p>

          <h2>13. Contact Us</h2>
          <p>
            For questions about these Terms or the Service, contact us at{" "}
            <a href="mailto:support@customspro.ai">support@customspro.ai</a>.
          </p>
        </div>

        <button className="close-btn" onClick={() => window.close()}>
          Close
        </button>
      </div>
    </div>
  );
};

export default Terms;